// @ts-nocheck
import { ButtonIconPresentationProps, ButtonPresentationProps } from "@insite/mobius/Button";
import constants from "@store/constants";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { productCompareRemoveButtonStyles } from "@store/Themes/common/mixins/productCompare";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const productCompareEmptySlides = (slidesTotal: number) => {
    let _index = 0;
    const _emptySlidesArray: Array<number> = [];

    while (_index < constants.productCompare.maxNumberOfColumns - slidesTotal) {
        _index++;
        _emptySlidesArray.push(_index);
    }

    return _emptySlidesArray;
};

export interface ProductCompareProps {
    removeProductFromCompareButton?: ButtonPresentationProps;
    removeProductFromCompareButtonIcon?: ButtonIconPresentationProps;
}

export const productCompareProps: ProductCompareProps = {
    removeProductFromCompareButton: {
        ...buttonResetProps,
        shape: "pill",
        size: 36,
        css: css`
            ${productCompareRemoveButtonStyles()}
            flex-shrink: 0;
            padding: 0 ${pxToRem(5)};
        `,
    },
    removeProductFromCompareButtonIcon: {
        src: Close,
        size: 14,
    },
};
